import { axios } from '~/clients';
import { GET_INSPECTION_LIST } from '~/constants/endpoints';
import type { InspectionReport } from '~/contracts/vdp';

type InspectionReportWithTypo = Omit<
  InspectionReport,
  'inspectionCategories'
> & {
  inspectonCategories: InspectionReport['inspectionCategories'];
};

export default function fetchInspectionReport(
  vehicleId: number
): Promise<InspectionReport> {
  return axios
    .get<InspectionReportWithTypo>(`${GET_INSPECTION_LIST}/${vehicleId}`)
    .then(({ data }) => ({
      ...data,
      inspectionCategories: data.inspectonCategories
    }));
}
